var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg01"},[_c('list-box',{ref:"listBox",on:{"load":_vm.load}},[_c('li',[_c('div',{staticClass:"h3"},[_vm._v("时间："+_vm._s(_vm.formatDate(_vm.titleDate)))])]),_vm._l((_vm.list),function(v,i){return _c('li',{key:i},[_c('realTimeMinute-card',{attrs:{"linkStatus":_vm.linkStatus,"dataObj":v}})],1)})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }